import { ROUTES } from "./routes";

export const CustomersNavigators: any[] = [
  {
    id: 1,
    name: "Territories",
    permission: ["view_dimensions_customers_territories"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("1"),
  },
  {
    id: 10,
    name: "Sales Person",
    permission: ["view_dimensions_customers_sales_rep"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("10"),
  },
  {
    id: 11,
    name: "Regions",
    permission: ["view_dimensions_customers_regions"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("11"),
  },
  {
    id: 2,
    name: "Zones",
    permission: ["view_dimensions_customers_zones"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("2"),
  },
  {
    id: 3,
    name: "Routes",
    permission: ["view_dimensions_customers_routes"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("3"),
  },
  {
    id: 4,
    name: "Categories",
    permission: ["view_dimensions_customers_categories"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("4"),
  },
  {
    id: 5,
    name: "Class",
    permission: ["view_dimensions_customers_class"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("5"),
  },
  {
    id: 6,
    name: "Limits",
    permission: [
      "view_dimensions_customers_limites",
      "view_dimensions_customers_limits",
    ],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("6"),
  },
  {
    id: 13,
    name: "Profit Center",
    permission: ["view_dimensions_customers_profit_center"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("13"),
  },
  {
    id: 15,
    name: "Demo",
    permission: ["view_dimensions_customers_demo"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("15"),
  },
];
export const ProductsNavigators: any[] = [
  {
    id: 7,
    name: "Categories",
    permission: ["view_dimensions_products_categories"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("7"),
  },
  {
    id: 8,
    name: "Groups",
    permission: ["view_dimensions_products_groups"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("8"),
  },
  {
    id: 9,
    name: "Origins",
    permission: ["view_dimensions_products_origins"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("9"),
  },
  {
    id: 12,
    name: "Vendors",
    permission: ["view_dimensions_products_vendors"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("12"),
  },
  {
    id: 14,
    name: "Business Line",
    permission: ["view_dimensions_products_business_line"],
    route: ROUTES.DIMENSIONS_TYPE_LIST_PAGE("14"),
  },
];

export const customerDimensionsPermissions: any[] = [
  "view_dimensions_customers_territories",
  "view_dimensions_customers_sales_rep",
  "view_dimensions_customers_regions",
  "view_dimensions_customers_zones",
  "view_dimensions_customers_routes",
  "view_dimensions_customers_categories",
  "view_dimensions_customers_class",
  "view_dimensions_customers_limits",
  "view_dimensions_customers_profit_center",
  "view_dimensions_customers_categories",
  "view_dimensions_customers_groups",
  "view_dimensions_customers_origins",
  "view_dimensions_customers_vendors",
  "view_dimensions_customers_demo",
];

export const productsDimensionsPermissions: any[] = [
  "view_dimensions_products_categories",
  "view_dimensions_products_groups",
  "view_dimensions_products_origins",
  "view_dimensions_products_vendors",
  "view_dimensions_products_business_line",
];
